import React from "react";
import { Redirect } from "react-router-dom";
import styled from "styled-components";
import { Paths } from "../Constants";
import BaseComponent from "./BaseComponent";
import AppHeaderSmall from "./common/AppHeaderSmall";
import Footer from "./common/Footer";
import MainContentWrapper from "./common/MainContentWrapper";
import PillButton from "./common/PillButton";
import Publisher from "./common/Publisher";
import SFCookieConsent from "./common/SFCookieConsent";
import SFLoader from "./common/SFLoader";
import SiteWrapper from "./common/SiteWrapper";
import Subscriber from "./common/Subscriber";
import TabBar from "./common/TabBar";
import ErrorDisplay from "./ErrorDisplay";

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

const PeopleWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 30px;
`;

const TabGroup = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  margin-top: 0px;
  background-color: white;
`;

const Tab = styled.div`
  margin-top: 0px;
  width: 50%;
  text-align: center;
  background-color: white;
  padding-top: 10px;
  padding-bottom: 10px;
  user-select: none;
`;

const TabSelected = styled.div`
  margin-top: 0px;
  width: 50%;
  border-bottom: solid 3px #eda142;
  text-align: center;
  background-color: white;
  padding-top: 10px;
  padding-bottom: 10px;
  user-select: none;
`;

class People extends BaseComponent {
  constructor() {
    super();
    this.state = {
      publishers: null,
      pendingPublishers: null,
      subscribers: null,
      pendingSubscribers: null,
      dataLoaded: false,
      selectedTabIndex: 0,
      tabButtons: ["Following", "Followers"],
    };
    this.getAll = this.getAll.bind(this);
    this.switchTab = this.switchTab.bind(this);
    this.getPublishers = this.getPublishers.bind(this);
    this.getSubscribers = this.getSubscribers.bind(this);
    this.cancelSubscriptionRequest = this.cancelSubscriptionRequest.bind(this);
  }

  async componentDidMount() {
    this.getAll();
  }

  async getPublishers() {
    if (!(await this.checkLogin())) {
      return;
    }

    try {
      const response = await this.safeFunApi.getPublishers();
      var publishers = [];
      var pendingPublishers = [];
      var i;
      for (i = 0; i < response.data.length; i++) {
        if (response.data[i].confirmed === 1) {
          publishers.push(response.data[i]);
        } else {
          pendingPublishers.push(response.data[i]);
        }
      }
      publishers.push.apply(publishers, pendingPublishers);
      this.setState({ publishers, pendingPublishers });
    } catch (err) {
      console.log(err);
      this.errorManager.addError(err.toString());
      this.forceUpdate();
    }
  }

  async getSubscribers() {
    if (!(await this.checkLogin())) {
      return;
    }

    try {
      const response = await this.safeFunApi.getSubscribers();
      var subscribers = [];
      var pendingSubscribers = [];
      var i;
      for (i = 0; i < response.data.length; i++) {
        if (response.data[i].confirmed === 1) {
          subscribers.push(response.data[i]);
        } else {
          pendingSubscribers.push(response.data[i]);
        }
      }

      let followersLabel = "Followers";
      if (pendingSubscribers.length > 0) {
        followersLabel += " (" + pendingSubscribers.length + ")";
      }
      this.setState({
        tabButtons: ["Following", followersLabel],
      });

      pendingSubscribers.push.apply(pendingSubscribers, subscribers);

      this.setState({ subscribers, pendingSubscribers });
    } catch (err) {
      console.log(err);
      this.errorManager.addError(err.toString());
      this.forceUpdate();
    }
  }

  async getAll() {
    try {
      await this.getPublishers();
      await this.getSubscribers();
      this.setState({ dataLoaded: true });
    } catch (err) {
      console.log(err);
      this.errorManager.addError(err.toString());
      this.forceUpdate();
    }
  }

  switchTab(data) {
    this.setState({ selectedTabIndex: data });
  }

  async cancelSubscriptionRequest(sfConsumerSubscriptionId) {
    if (!(await this.checkLogin())) {
      return;
    }

    const response = await this.safeFunApi.cancelSubscriptionRequest(
      sfConsumerSubscriptionId
    );
    if (!response.data.success) {
      this.errorManager.addError("Failed to cancel the pending follow request");
      this.forceUpdate();
      return;
    }
    this.getPublishers();
  }

  async confirmSubscriptionRequest(sfConsumerSubscriptionId) {
    if (!(await this.checkLogin())) {
      return;
    }

    const response = await this.safeFunApi.confirmSubscriptionRequest(
      sfConsumerSubscriptionId
    );
    if (!response.data.success) {
      this.errorManager.addError("Failed to confirm the follow request");
      this.forceUpdate();
      return;
    }
    this.getAll();
  }

  async declineSubscriptionRequest(sfConsumerSubscriptionId) {
    if (!(await this.checkLogin())) {
      return;
    }

    const response = await this.safeFunApi.declineSubscriptionRequest(
      sfConsumerSubscriptionId
    );
    if (!response.data.success) {
      this.errorManager.addError("Failed to decline the follow request");
      this.forceUpdate();
      return;
    }
    this.getSubscribers();
  }

  async deleteSubscription(sfConsumerSubscriptionId) {
    if (!(await this.checkLogin())) {
      return;
    }

    const response = await this.safeFunApi.deleteSubscription(
      sfConsumerSubscriptionId
    );
    if (!response.data.success) {
      this.errorManager.addError("Failed to delete the follower");
      this.forceUpdate();
      return;
    }
    this.getSubscribers();
  }

  render() {
    return (
      <SiteWrapper>
        {this.state.redirectPath ? (
          <Redirect
            to={{
              pathname: this.state.redirectPath,
              search: this.state.redirectSearch,
              state: this.state.redirectState,
            }}
          />
        ) : null}

        <AppHeaderSmall title="People" />
        <SFLoader active={!this.state.dataLoaded} />
        <MainContentWrapper>
          <TabBar people />
          <Wrapper>
            <TabGroup>
              {this.state.selectedTabIndex === 0 ? (
                <>
                  <TabSelected
                    style={{
                      borderRightWidth: 1,
                      borderRightStyle: "solid",
                      borderRightColor: "black",
                    }}
                  >
                    {this.state.tabButtons[0]}
                  </TabSelected>
                  <Tab
                    onClick={() => {
                      this.setState({ selectedTabIndex: 1 });
                    }}
                  >
                    {this.state.tabButtons[1]}
                  </Tab>
                </>
              ) : (
                <>
                  <Tab
                    style={{
                      borderRightWidth: 1,
                      borderRightStyle: "solid",
                      borderRightColor: "black",
                    }}
                    onClick={() => {
                      this.setState({ selectedTabIndex: 0 });
                    }}
                  >
                    {this.state.tabButtons[0]}
                  </Tab>
                  <TabSelected> {this.state.tabButtons[1]}</TabSelected>
                </>
              )}
            </TabGroup>

            {this.state.selectedTabIndex === 0 ? (
              <>
                <PillButton
                  onClick={() => {
                    this.redirect(Paths.ADD_PUBLISHER);
                  }}
                  primary
                  style={{
                    marginTop: 20,
                    width: 150,
                  }}
                >
                  Add
                </PillButton>

                {this.state.publishers &&
                this.state.publishers.length &&
                this.state.publishers.length > 0 ? (
                  <PeopleWrapper>
                    {this.state.publishers.map((publisher) =>
                      publisher.confirmed === 1 ? (
                        <div
                          key={publisher.sF_ConsumerSubscriptionId}
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            this.redirect(Paths.FOLLOWING, "", {
                              publisher,
                            });
                          }}
                        >
                          <Publisher item={publisher} />
                        </div>
                      ) : (
                        <Publisher
                          item={publisher}
                          callback={() => {
                            this.cancelSubscriptionRequest(
                              publisher.sF_ConsumerSubscriptionId
                            );
                          }}
                        />
                      )
                    )}
                  </PeopleWrapper>
                ) : null}
              </>
            ) : null}

            {this.state.selectedTabIndex === 1 ? (
              <>
                {this.state.pendingSubscribers &&
                this.state.pendingSubscribers.length &&
                this.state.pendingSubscribers.length > 0 ? (
                  <PeopleWrapper>
                    {this.state.pendingSubscribers.map((subscriber) =>
                      subscriber.confirmed === 0 ? (
                        <Subscriber
                          item={subscriber}
                          key={subscriber.sF_ConsumerSubscriptionId}
                          confirmCallback={() => {
                            this.confirmSubscriptionRequest(
                              subscriber.sF_ConsumerSubscriptionId
                            );
                          }}
                          declineCallback={() => {
                            this.declineSubscriptionRequest(
                              subscriber.sF_ConsumerSubscriptionId
                            );
                          }}
                        />
                      ) : (
                        <div
                          key={subscriber.sF_ConsumerId}
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            this.redirect(Paths.FOLLOWER, "", {
                              subscriber,
                            });
                          }}
                        >
                          <Subscriber
                            item={subscriber}
                            callback={() => {
                              this.cancelSubscriptionRequest(
                                subscriber.sF_ConsumerSubscriptionId
                              );
                            }}
                          />
                        </div>
                      )
                    )}
                  </PeopleWrapper>
                ) : null}
              </>
            ) : null}

            {this.errorManager.getErrorCount() > 0 ? (
              <ErrorDisplay errorManager={this.errorManager} />
            ) : null}
          </Wrapper>
        </MainContentWrapper>
        <Footer />
        <SFCookieConsent />
      </SiteWrapper>
    );
  }
}

export default People;
